import { atom, useAtom } from 'jotai';

/** Selected Scout Agent chat id (sidebar selection). Synced with URL query param. */
export const selectedScoutChatIdAtom = atom<string | null>(null);

/**
 * Latest saved-search filter hash (`query_md5`) reported by a Scout chat
 * turn, keyed by `adk_query_id`. A chat turn only reports the searches it
 * actually changed, so this accumulates rather than replacing wholesale.
 * Consumers key their fetches off the relevant entry to know when a
 * scoutbot-sourced saved search's filters need to be refetched.
 */
const savedSearchQueryHashAtom = atom<Record<string, string>>({});

export const useSavedSearchQueryHash = () => useAtom(savedSearchQueryHashAtom);
